import * as moment from "moment";
export class COC {
  id: string;
  bastidor: string;
  tipoSolicitud: string;
  fechaCreacion: string;
  analista: string;
  estado: string;
  comentarios: string;

  static cocFromJson(obj: Object) {
    let tcertificado = obj["tipoReforma"]
      ? obj["tipoCertificado"] + " " + obj["tipoReforma"]
      : obj["tipoCertificado"];
    return new COC(
      obj["solicitud"],
      obj["bastidor"],
      tcertificado,
      moment(obj["fechaCreacion"]).format("DD/MM/yyyy"),
      obj["usuario"],
      obj["estado"],
      obj["comentarios"]
    );
  }

  constructor(
    id: string,
    peBastidor: string,
    tipoSolicitud: string,
    peCreacion: string,
    usuario: string,
    estado: string,
    comentarios: string
  ) {
    this.id = id;
    this.bastidor = peBastidor;
    this.tipoSolicitud = tipoSolicitud;
    this.fechaCreacion = peCreacion;
    this.analista = usuario;
    this.estado = estado;
    this.comentarios = comentarios;
  }
}
